import './CompanyProfile.css';
import Translator from '../../translates/Translator';
import hexes from '../../assets/img/hexes';

const CompanyProfile = ({ isMobile }) => {
    const t = Translator();

    return (
        <div className='company-profile'>
            <img src={hexes.h3_80} className="hex3 o-50" alt='' />
            {(isMobile) ? (
                <span>
                    <h1>{t("company-profile")}</h1>
                    <div className='cprofile-panel'>
                        <p>{t("cprofile-text1")} <span className='primary'>{t("cprofile-bold-text1")}</span>{t("cprofile-text2")}</p>
                        <p>{t("cprofile-text3")}</p>
                    </div>
                    <ul className='my-4'>
                        <li>
                            <div class="feature-icon">✓</div>
                            <p className='cprofile-points'>
                                <span className='primary'>{t("cprofile-bold-text2")}</span> {t("cprofile-text4")}
                            </p>
                        </li>
                        <li>
                            <div class="feature-icon">✓</div>
                            <p className='cprofile-points'>
                                <span className='primary'>{t("cprofile-bold-text4")}</span> {t("cprofile-text6")}
                            </p>
                        </li>
                        <li>
                            <div class="feature-icon">✓</div>
                            <p className='cprofile-points'>
                                <span className='primary'>{t("cprofile-bold-text5")}</span> {t("cprofile-text7")}
                            </p>
                        </li>
                        <li>
                            <div class="feature-icon">✓</div>
                            <p className='cprofile-points'>
                                <span className='primary'>{t("cprofile-bold-text6")}</span> {t("cprofile-text8")}
                            </p>
                        </li>
                    </ul>
                </span>
            ) : (
                <span className='d-flex cprofile-container'>
                    <div className='cprofile-panel'>
                        <h1>{t("company-profile")}</h1>
                        <p>
                            {t("cprofile-text1")} <span className='primary'>{t("cprofile-bold-text1")}</span>{t("cprofile-text2")}
                        </p>
                        <p>
                            {t("cprofile-text3")}
                        </p>
                    </div>
                    <div className='cprofile-points-container'>
                        <div className='br-4'>
                            <span className='primary'>{t("cprofile-bold-text2")}</span> {t("cprofile-text4")}
                        </div>
                        <div className='br-4'>
                            <span className='primary'>{t("cprofile-bold-text4")}</span> {t("cprofile-text6")}
                        </div>
                        <div className='br-4'>
                            <span className='primary'>{t("cprofile-bold-text5")}</span> {t("cprofile-text7")}
                        </div>
                        <div className='br-4'>
                            <span className='primary'>{t("cprofile-bold-text6")}</span> {t("cprofile-text8")}
                        </div>
                    </div>
                </span>
            )}
        </div>
    );
}

export default CompanyProfile;